import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";
import {
	rightToLeftArrowAnimation,
	verticalArrowAnimation
} from "../animations";

export const Container = styled.div<{
	$anchorCenterOffset?: number;
	$anchorLeft?: number;
	$anchorOffset?: number;
	$anchorTop?: number;
	$arrowCenter?: number;
	$placement?: "above" | "below" | "left" | "right";
}>`
	display: flex;
	flex-direction: column;
	position: fixed;
	z-index: 10003;
	left: ${({ $anchorLeft = 0 }) => `${$anchorLeft}px`};
	top: ${({ $anchorTop = 0 }) => `${$anchorTop}px`};
	transform: translate(
		${({
			$anchorCenterOffset = 0,
			$anchorOffset = 5.6,
			$arrowCenter = 3.3,
			$placement = "above"
		}) =>
			$placement === "left"
				? `calc(-100% - ${$anchorOffset + 1}em)`
				: $placement === "right"
				? `${$anchorOffset + 2}em`
				: `calc(${$anchorCenterOffset}px - ${$arrowCenter}em)`},
		${({ $anchorOffset = 5.6, $placement = "above" }) =>
			$placement === "left" || $placement === "right"
				? "-50%"
				: $placement === "below"
				? `${$anchorOffset}em`
				: `calc(-100% - ${$anchorOffset}em)`}
	);
	visibility: ${({ $anchorTop }) =>
		$anchorTop === undefined ? "hidden" : "visible"};
`;

export const SlideNumber = styled.div`
	color: #fff;
	text-align: right;
	font-family: Baloo;
	font-size: 1.6em;
	font-style: normal;
	font-weight: 400;
	line-height: 112.5%;
	text-align: right;
	margin-right: 0.7em;
`;

export const Slide = styled.div<{ $backgroundImage: string }>`
	background-image: url(${({ $backgroundImage }) => $backgroundImage});
	background-size: cover;
	width: 33.1em;
	height: 12.2334em;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
`;

export const Content = styled.div`
	width: fit-content;
	position: relative;
	top: -1em;
	left: 3em;
	display: flex;
	flex-direction: column;
	gap: 0.5em;
`;

export const Tiki = styled.img`
	position: absolute;
	left: -1.5em;
	bottom: 1.1em;
	width: 10.5em;
	height: 11.8em;
`;

export const SlideContent = styled.div`
	font-family: Inter;
	color: #462c12;
	text-align: left;

	span {
		paint-order: stroke fill;
		-webkit-text-stroke-width: 0.1em;
		-webkit-text-stroke-color: #fbbd05;
	}
`;

export const Title = styled(SlideContent)`
	font-size: 1.6em;
	font-weight: 700;
	line-height: 112.5%;
	z-index: 0;
`;

export const Subtitle = styled(SlideContent)`
	font-size: 1.2em;
	font-weight: 400;
	line-height: 116.667%;
`;

export const NextButton = styled(ThemeButton)`
	font-size: 1.8em;
	width: 6.2222em;
	height: 2.2777em;
	border-radius: 0.6666em;
	position: absolute;
	bottom: -0.7em;
`;

export const SkipButton = styled.button`
	background: none;
	border: none;
	color: #fff;
	font-family: Baloo;
	font-size: 1.8em;
	filter: drop-shadow(0 0.1111em 1.6666em rgba(0, 0, 0, 0.35));
	position: absolute;
	bottom: -2em;
	right: 0;
	padding: 0.7em;
	cursor: pointer;
`;

export const ArrowDownContainer = styled.div<{ $right?: number }>`
	position: absolute;
	top: -5.5em;
	right: ${({ $right = 7 }) => `${$right}em`};
	bottom: unset;
	left: unset;
	${verticalArrowAnimation}

	&.down {
		top: unset;
		right: unset;
		bottom: -5.6em;
		left: 1em;
	}

	&.right {
		top: 4.5em;
		right: -6em;
		${rightToLeftArrowAnimation}
	}

	&.left {
		top: 4.5em;
		right: unset;
		left: -6em;
		${rightToLeftArrowAnimation}
	}
`;

export const Arrow = styled.img`
	display: block;
	width: 4.6em;
	height: 5.6em;

	&.down {
		transform: rotate(180deg);
	}

	&.right {
		transform: rotate(90deg);
	}

	&.left {
		transform: rotate(-90deg);
	}
`;
